import DataTable from "react-data-table-component";

const CollapsibleTable = ({
  title,
  columns,
  data,
  pagination,
  paginationPerPage,
  paginationRowsPerPageOptions,
  onChangeRowsPerPage,
  onChangePage,
  totalRowCount,
  currentPage,
  paginationServer = true,
  onSort,
  serverSideSort,
  sortColumn,
  sortDirection,
  NoRecordsText,
  fixedHeader,
  fixedHeaderScrollHeight,
  onRowClick,
  expandableRowExpanded,
  // nestedColumns,
  expandedRows,
  nestedColumns,
}) => {
  // Child table columns
  // const nestedColumns = [
  //   {
  //     name: "Sub ID",
  //     selector: (row) => row.subId,
  //     sortable: true,
  //   },
  //   {
  //     name: "Sub Name",
  //     selector: (row) => row.subName,
  //     sortable: true,
  //   },
  //   {
  //     name: "Quantity",
  //     selector: (row) => row.qty,
  //   },
  // ];

  // Component that shows when row is expanded
  const ExpandedComponent = ({ data }) => (
    <div className="p-3 bg-light rounded">
      <DataTable
        columns={nestedColumns}
        data={data.children || []}
        dense
        striped
        highlightOnHover
        noHeader
        className={
          data?.length === 0 || data?.length === undefined
            ? "no-data-table border-radius-none font-size-14"
            : "data-table border-radius-none font-size-14"
        }
      />
    </div>
  );

  return (
    <DataTable
      title={title}
      columns={columns}
      data={data}
      pagination={pagination}
      paginationPerPage={paginationPerPage}
      paginationRowsPerPageOptions={
        paginationRowsPerPageOptions || [10, 25, 50, 100, 200]
      }
      onChangeRowsPerPage={onChangeRowsPerPage}
      onChangePage={onChangePage}
      paginationTotalRows={totalRowCount}
      paginationDefaultPage={currentPage}
      paginationServer={paginationServer}
      onSort={onSort}
      sortServer={serverSideSort}
      sortColumn={sortColumn}
      sortDirection={sortDirection}
      defaultSortField={sortColumn}
      defaultSortAsc={sortDirection === "asc"}
      onRowExpandToggled={(expanded, row) => {
        onRowClick(expanded, row);
      }}
      expandableRowExpanded={(row) => expandedRows[row._id] || false}
      noDataComponent={
        <b className="table-no-data-text mt-5 fs-4 mb-5">
          {NoRecordsText || "No data found"}
        </b>
      }
      className={
        data?.length === 0 || data?.length === undefined
          ? "no-data-table border-radius-none font-size-14"
          : "data-table border-radius-none font-size-14"
      }
      fixedHeader={fixedHeader}
      fixedHeaderScrollHeight={fixedHeaderScrollHeight}
      // 👇 collapsible rows
      expandableRows
      expandableRowsComponent={ExpandedComponent}
      expandableIcon={{ collapsed: "▶️", expanded: "🔽" }}
    />
  );
};

export default CollapsibleTable;
